import { Field, reduxForm } from 'redux-form';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import { SubmitBatchPaperClaimsForNonEDIPayers, SubmitBatchPaperClaimsForNonEDISecondaryPayers } from '../manageClaims/actions/ManageClaimActions';
import { renderAutoCompleteSingleSelect } from '../../../../components/reduxFields';
import { CommonButton } from '../../../../components/buttons';
import SmallLoader from '../../../../img/small-loader.gif';

const validate = (values) => {
  const errors = {};  
  if (!values.payerPreference) {
    errors.payerPreference = 'Please select payer preference.';
  }
  if (!values.claimFormPrintFormat) {
    errors.claimFormPrintFormat = 'Please select print format.';
  }
  return errors;
};

class BatchGenerateForm1500SecondaryModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      PayerPreference: [{ id: 'primary', value: 'Primary' }, { id: 'secondary', value: 'Secondary' }],
      ClaimFormPrintFormat: [{ id: 1, value: 'Normal' }, { id: 2, value: 'Pre-Printed' }],
    };
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
  }

  componentWillReceiveProps(nextProps) {

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  onSubmitHandler(formData) {
    let postData = {
      claimIds: this.props.selectedEDIAndNonEDIClaimIds,
      payerPreference: formData.payerPreference,      
      printFormat: formData.claimFormPrintFormat,
    };
    // console.log(JSON.stringify(postData));
    if(formData.payerPreference === 'primary')
    {
      this.props.SubmitBatchPaperClaimsForNonEDIPayers(postData.claimIds, postData.payerPreference, false, postData.printFormat, 'SUBMITTED');
    }
    else
    {
      this.props.SubmitBatchPaperClaimsForNonEDISecondaryPayers(postData.claimIds, postData.payerPreference, postData.printFormat);
    }
    this.handleClose();
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    const actions = [
      <CommonButton label="Cancel" className="mr-15 grey_btn" onTouchTap={() => this.handleClose()} />,
      <CommonButton type="submit" primary={true} label="Generate Claim(s)" onTouchTap={handleSubmit(this.onSubmitHandler)} />,
    ];
    return (
      <Dialog className="custom_modal"
        title={'Generate Batch Form 1500'}
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>
        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">                              
              <div className='col-sm-6 require  mt-35'>
                  <Field
                    name="payerPreference"
                    label="Payer Preference"
                    options={this.state.PayerPreference}
                    handleNewRequest={this.handleNewRequest}
                    component={renderAutoCompleteSingleSelect} />
                </div>
                <div className='col-sm-6 require  mt-35'>
                  <Field
                    name="claimFormPrintFormat"
                    label="Print Formats"
                    options={this.state.ClaimFormPrintFormat}
                    handleNewRequest={this.handleNewRequest}
                    component={renderAutoCompleteSingleSelect} />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  };
}

BatchGenerateForm1500SecondaryModal = reduxForm({
  form: 'BatchGenerateForm1500SecondaryModal',
  validate,
  enableReinitialize: true,
})(BatchGenerateForm1500SecondaryModal);

//const selector = formValueSelector('BatchGenerateForm1500SecondaryModal');
function mapStateToProps(state) {
  return {
    loading: state.billing.loading,
  };
}

export default connect(mapStateToProps, { SubmitBatchPaperClaimsForNonEDIPayers, SubmitBatchPaperClaimsForNonEDISecondaryPayers })(BatchGenerateForm1500SecondaryModal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/BatchGenerateForm1500Secondary_Modal.js